import { NormalizedListing } from '@ha/algolia';
import { Currency } from 'ha/constants/Currencies';
import { ListingCancellationPolicy } from 'ha/services/apiV2/types/Listing';
import { isAlgoliaListingFurnished } from '../ListingFacilities/isListingFurnished';

import { NormalizedAlgoliaListing } from './types';

type RequiredAlgoliaListingParams = Pick<
  NormalizedListing,
  | 'id'
  | 'advertiserId'
  | 'price'
  | 'currency'
  | 'street'
  | 'city'
  | 'isNew'
  | 'propertyType'
  | 'previewImage'
  | 'photos'
  | 'photoCount'
  | 'floorPlanCount'
  | 'videoCount'
  | 'minimalRentalPeriod'
  | 'listingPath'
  | 'exclusions'
  | 'currentOccupancy'
  | 'freePlaces'
  | 'cPolicy'
  | 'utilities'
  | 'facility_bedroom_furnished'
  | 'facility_bed'
  | 'facility_bedroom_count'
  | 'facility_total_size'
  | 'facility_bedroom_size'
  | 'facility_registration_possible'
  | 'minPrice'
  | 'maxPrice'
  | 'priceType'
>;

export function normalizeAlgoliaListing(
  listing: RequiredAlgoliaListingParams,
): NormalizedAlgoliaListing {
  return {
    id: listing.id,
    advertiserId: listing.advertiserId,
    price: listing.price,
    currency: listing.currency as Currency,
    street: listing.street,
    city: listing.city,
    isNew: listing.isNew,
    cPolicy: listing.cPolicy as ListingCancellationPolicy,
    previewImage: listing.previewImage,
    photos: listing.photos,
    photoCount: listing.photoCount,
    floorPlanCount: listing.floorPlanCount ?? 0,
    videoCount: listing.videoCount ?? 0,
    minimalRentalPeriod: listing.minimalRentalPeriod,
    listingPath: listing.listingPath,
    propertyType: listing.propertyType,
    currentOccupancy: listing.currentOccupancy,
    freePlaces: listing.freePlaces,
    exclusions: listing.exclusions,
    bedroomFurnished: isAlgoliaListingFurnished(listing) ? 'yes' : 'no',
    bedroomCount: listing.facility_bedroom_count,
    totalSize: listing.facility_total_size,
    bedroomSize: listing.facility_bedroom_size,
    registrationPossible: listing.facility_registration_possible,
    utilities: listing.utilities,
    minPrice: listing.minPrice,
    maxPrice: listing.maxPrice,
    priceType: listing.priceType,
  };
}
